import {MathUtils, Vector3, type Vector2} from 'three'

import type MainMona from './main-mona'

const X_AXIS = new Vector3(1, 0, 0)
const Y_AXIS = new Vector3(0, 1, 0)
const FACE_SMOOTHING = 3
const MAX_YAW = MathUtils.degToRad(30)
const MAX_PITCH = MathUtils.degToRad(15)

export function handleFacePointer(target: Vector2, event: MouseEvent, rect: DOMRect, radius?: number) {
  const x = event.clientX - (rect.left + rect.width * 0.5)
  const y = event.clientY - (rect.top + rect.height * 0.5)
  if (radius !== undefined && Math.hypot(x, y) > radius) {
    target.set(0, 0)
    return
  }

  target.set(MathUtils.clamp(x / rect.width, -0.5, 0.5), MathUtils.clamp(-y / rect.height, -0.5, 0.5))
}

export function updateFaceInteraction(mona: MainMona, position: Vector2, target: Vector2, delta: number) {
  position.lerp(target, 1 - Math.exp(-delta * FACE_SMOOTHING))
  const yaw = MathUtils.clamp(position.x * MAX_YAW * 2, -MAX_YAW, MAX_YAW)
  const pitch = MathUtils.clamp(-position.y * MAX_PITCH * 2, -MAX_PITCH, MAX_PITCH)

  mona.facingQuaternion.setFromAxisAngle(Y_AXIS, yaw)
  mona.verticalTiltQuaternion.setFromAxisAngle(X_AXIS, mona.restingPitch + pitch)
  mona.horizontalTiltQuaternion.identity()
  mona.verticalTiltUniform.value = MathUtils.clamp(-position.y * mona.verticalTiltStrength, -0.1, 0)
  mona.applyRotation()
  mona.updateMovement(0, delta)
}
